import type { AnchorHTMLAttributes, MouseEvent } from 'react';
import { navigate } from '../lib/navigation';

interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  navigationState?: Record<string, unknown>;
}

export function Link({ href, navigationState, onClick, ...props }: LinkProps) {
  function handleClick(event: MouseEvent<HTMLAnchorElement>): void {
    onClick?.(event);
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      props.target === '_blank' ||
      href.startsWith('http')
    ) {
      return;
    }
    event.preventDefault();
    navigate(href, { state: navigationState });
  }

  return <a href={href} onClick={handleClick} {...props} />;
}
